import { Outlet } from "react-router-dom";
import { Sidebar } from "./Sidebar";

export function BrandedShell() {
  return (
    <div className="school-shell flex h-screen flex-col overflow-hidden bg-[var(--school-bg)] text-[var(--school-text)] md:flex-row">
      <Sidebar />
      <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
        <main className="school-main flex-1 overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
